import type { SVGProps } from 'react';

import { Icon } from './Icon';

const ArrowRightAltIcon = (props: SVGProps<SVGSVGElement>) => (
  <Icon viewBox="0 0 20 20" {...props}>
    <path
      d="M11.5385 14.7115L10.6603 13.8077L13.843 10.625H3.75002V9.37499H13.843L10.6603 6.19229L11.5385 5.28845L16.25 9.99997L11.5385 14.7115Z"
      fill="currentColor"
    />
  </Icon>
);

export default ArrowRightAltIcon;
